// extracted by mini-css-extract-plugin
export default {"site_header":"Menu_site_header__XbFWE"};